import React, {useMemo} from 'react';
import {JSONContent} from '../../pages/GuidebookView/types';
import {MARK_TYPES} from '../../pages/GuidebookView/constants';

const useBuildContent = (content: JSONContent[]) => {
  const buildedContent = useMemo(() => {
    const buildTextWithMarks = (node: JSONContent) => {
      if (node.type === 'hardBreak') {
        return <br />;
      }

      let result: JSX.Element | string = node.text || '';

      if (!node.marks?.length) {
        return result;
      }

      node.marks.forEach(mark => {
        switch (mark.type) {
          case MARK_TYPES.BOLD:
            result = <strong>{result}</strong>;
            break;
          case MARK_TYPES.ITALIC:
            result = <em>{result}</em>;
            break;
          case MARK_TYPES.UNDERLINE:
            result = <u>{result}</u>;
            break;
          case MARK_TYPES.STRIKE:
            result = <s>{result}</s>;
            break;
          case MARK_TYPES.LINK:
            result = (
              <a
                href={mark.attrs?.href}
                target={mark.attrs?.target}
                rel={mark.attrs?.rel}
                className={mark.attrs?.class}
              >
                {result}
              </a>
            );
            break;
        }
      });

      return result;
    };

    return (
      <>
        {content.map((node, index) => (
          <React.Fragment key={index}>{buildTextWithMarks(node)}</React.Fragment>
        ))}
      </>
    );
  }, [content]);

  return buildedContent;
};

export {useBuildContent};
